module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('v-row', {
    staticClass: "fill-height"
  }, [_c('v-col', [_c('v-sheet', {
    attrs: {
      "height": "64"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.setToday
    }
  }, [_vm._v("Today")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "fab": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": _vm.next
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "outlined": ""
          }
        }, on), [_c('span', [_vm._v(_vm._s(_vm.typeToLabel[_vm.type]))]), _vm._v(" "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-menu-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'day'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Day")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'week'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Week")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.type = 'month'
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Month")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-sheet', {
    attrs: {
      "height": "600"
    }
  }, [_c('v-calendar', {
    ref: "calendar",
    style: ({
      maxHeight: '1000px',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }),
    attrs: {
      "color": "primary",
      "events": _vm.events,
      "event-color": _vm.getEventColor,
      "event-margin-bottom": 3,
      "now": _vm.today,
      "type": _vm.type
    },
    on: {
      "click:event": _vm.showEvent,
      "click:more": _vm.viewDay,
      "click:date": _vm.viewDay,
      "change": _vm.updateRange
    },
    model: {
      value: (_vm.focus),
      callback: function($$v) {
        _vm.focus = $$v
      },
      expression: "focus"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "activator": _vm.selectedElement,
      "offset-x": "",
      "min-width": "350px",
      "max-width": "350px"
    },
    model: {
      value: (_vm.selectedOpen),
      callback: function($$v) {
        _vm.selectedOpen = $$v
      },
      expression: "selectedOpen"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "grey lighten-4",
      "min-width": "350px",
      "max-width": "350px",
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "color": _vm.selectedEvent.color,
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedEvent.name)
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Campaign : "), _c('strong', [_vm._v(_vm._s(_vm.selectedEvent.campaignName))])]), _vm._v(" "), (_vm.selectedEvent.influencer) ? _c('p', [_vm._v("Influencer :\n                "), _vm._v(" "), _c('social-handle', {
    attrs: {
      "divClassName": "d-inline",
      "isInstagram": _vm.selectedEvent.platform === 'instagram' || !_vm.selectedEvent.platform,
      "isTikTok": _vm.selectedEvent.platform === 'tiktok',
      "isYoutube": _vm.selectedEvent.platform === 'youtube',
      "isFacebook": _vm.selectedEvent.platform === 'facebook',
      "isXiaohongshu": _vm.selectedEvent.platform === 'xiaohongshu',
      "instagramHandle": _vm.selectedEvent.influencer,
      "tiktokHandle": _vm.selectedEvent.influencer,
      "youtubeHandle": _vm.selectedEvent.influencer,
      "facebookHandle": _vm.selectedEvent.influencer,
      "xiaohongshuHandle": _vm.selectedEvent.influencer,
      "xiaohongshuFullName": _vm.selectedEvent.influencer
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Live Date : "), _c('strong', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.selectedEvent.liveDate)))])]), _vm._v(" "), _c('p', [_vm._v("Last Stats Submission Date : "), _c('strong', [_vm._v(_vm._s(_vm.changeDateFormat(_vm.selectedEvent.end)))])]), _vm._v(" "), (_vm.selectedEvent.postLinks && _vm.selectedEvent.postLinks.length) ? _c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('p', [_vm._v("Post Links : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, _vm._l((_vm.selectedEvent.postLinks), function(item, idx) {
    return _c('div', {
      key: idx
    }, [_c('a', {
      attrs: {
        "href": item,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item))])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.selectedOpen = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.selectedEvent.stats) ? _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewStatsLink(_vm.selectedEvent)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('span', [_vm._v("View Stats")])]) : _c('v-btn', _vm._g(_vm._b({
    attrs: {
      "color": "secondary",
      "small": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.copyFormLink(_vm.selectedEvent)
      }
    }
  }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")]), _vm._v(" "), _c('span', [_vm._v("Copy Stats Submission")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n          Please stand by\n          "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "post": _vm.viewPostData,
      "csActions": false,
      "saleActions": false,
      "clientActions": false,
      "influencerActions": false,
      "cs_inf_chatbox": false,
      "postAbuseHistory": false,
      "postReviewApproved": false,
      "postHistory": false,
      "userObj": _vm.user,
      "value": _vm.viewPostDialog
    },
    model: {
      value: (_vm.viewPostDialog),
      callback: function($$v) {
        _vm.viewPostDialog = $$v
      },
      expression: "viewPostDialog"
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n      Copied to Clipboard!\n      "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-link"
    },
    domProps: {
      "value": _vm.formLink
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf026c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/CalenderViewPosts.vue
// module id = 2057
// module chunks = 0